module.exports = __webpack_public_path__ + "media/images/logo-customer-classdojo-1afcbc91.png";